<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Notas' | nomenclatura | async}}</ion-title>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>

  <div class="ion-padding" style="padding-bottom: 0">
    <ion-list class="remove-border">
      <ion-list-header>
        <h2 class="evento-title">{{encontro.materia}}</h2>
      </ion-list-header>

      <ion-item>
        <ion-label style="margin: 0px !important">
          <span class="data-aula">
            {{encontro.dataInicio | dateFormat:'ddmmyyyy'}} -
            {{encontro.dataInicio | dateFormat:'hora'}}
          </span>
        </ion-label>
      </ion-item>
    </ion-list>
  </div>

  <div
    *ngFor="let atividade of atividades"
    class="ion-margin-start ion-margin-end"
  >
    <ion-card *ngIf="atividades.length">
      <form-atividade-nota
        [atividade]="atividade"
        class="notas-atividades"
      ></form-atividade-nota>
    </ion-card>
  </div>

  <ion-grid>
    <ion-row class="ion-justify-content-center">
      <ion-col size="8">
        <ion-button class="btn-default" (click)="salvarNotas()">
          {{'Salvar' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
